import {isFeatureEnabled} from '@github-ui/feature-flags'

/**
 * Whether the header's title comes from the secondary view's TanStack document with the optimistic
 * overlay applied to it.
 *
 * Necessary but not sufficient for the native producer: the document must also have resolved, so
 * that decision follows the header's actual read rather than this flag.
 */
export function readsTitleFromOverlaidSecondary(): boolean {
  return isFeatureEnabled('issue_viewer_secondary_view_tanstack')
}
